export function copyText (context, text, notifyText) {
  window.navigator.clipboard.writeText(text)

  context.$notify({
    group: 'lsg-notify',
    text: notifyText || 'Текст скопирован в буфер обмена'
  })
}

export function markRowToChange (nodeContainer, rowId, removeMark = false) {
  let desktopTableRow, mobileTableRow

  desktopTableRow = nodeContainer.querySelector(`span[id="${rowId}"]`)

  if (desktopTableRow) {
    desktopTableRow = desktopTableRow.closest('tr')
  }

  if (desktopTableRow) {
    if (!removeMark) {
      desktopTableRow.classList.add('marked-to-wait')
    } else {
      desktopTableRow.classList.remove('marked-to-wait')
    }
  }

  mobileTableRow = nodeContainer.querySelector(`.tbl__task[id="${rowId}"]`)

  if (mobileTableRow) {
    if (!removeMark) {
      mobileTableRow.classList.add('marked-to-wait')
    } else {
      mobileTableRow.classList.remove('marked-to-wait')
    }
  }
}
